import React, { useState, useContext, useEffect, useRef } from 'react'
import { ContainerBody, CustomDatePicker, DepthInput, EditingHeader, Footer, FromDatePicker, Header, Selector, ToDatePicker, WrapperDepth, __SOURCE_ILT__, getUnixFromDateAndTime, getWellName, makeHisotry } from '../commom'
import { DashboardContext } from 'live/context/dashboard'
import Authorization from 'live/services/authorization'
import DateService from 'live/services/date'
import { ILTAnnotationExtra, ILTEditionForm } from '../types'
import { __SOURCE_METADATA__ } from "../commom"
import api from '../../api'

const exclusionOptions = [
    { value: true, label: "Yes" },
    { value: false, label: "No" }
]

const operationTypeOptions = [
    { value: "N", label: "N" },
    { value: "L", label: "L" }
]

function makeExtra(event, form, wellName) {
    const extra: ILTAnnotationExtra = {
        authorId: Authorization.user.id,
        author: Authorization.user.username,
        manual_depthFrom: form.manual_depthFrom,
        manual_depthTo: form.manual_depthTo,
        manual_exclude: form.manual_exclude ?? false,
        manual_iltActivity: form.manual_iltActivity,
        manual_iltSubActivity: form.manual_iltSubActivity,
        manual_code: form.manual_code,
        manual_subcode: form.manual_subcode,
        manual_timeType: form.manual_timeType,
        manual_section: form.manual_section,
        manual_bit_crossing_1000_timestamp: (form.bit_crossing_1000_date && form.bit_crossing_1000_time) ? getUnixFromDateAndTime(form.bit_crossing_1000_date, form.bit_crossing_1000_time) : null,
        manual_bit_crossing_casing_shoe_timestamp: (form.bit_crossing_casing_shoe_date && form.bit_crossing_casing_shoe_time) ? getUnixFromDateAndTime(form.bit_crossing_casing_shoe_date, form.bit_crossing_casing_shoe_time) : null,
        wellbore_name: wellName,
        section_name: event?.section_name,
        activity_name_final_event: event?.activity_name_final_event,
        sub_activity_name_final_event: event?.sub_activity_name_final_event,
        code: event?.code,
        subcode: event?.subcode,
        time_type: event?.time_type,
        from_depth_final: event?.from_depth_final,
        to_depth_final: event?.to_depth_final,
        bit_crossing_1000_timestamp: event?.bit_crossing_1000_timestamp,
        bit_crossing_casing_shoe_timestamp: event?.bit_crossing_casing_shoe_timestamp
    }

    return extra
}

function validateTimestamp(date, time) {
    return !!date && !!time ? isNaN(getUnixFromDateAndTime(date, time)) : false
}

export default function (props) {
    const { mode = 'temporal', event, onHide } = props
    if (mode !== 'temporal') {
        console.error('Timeline mode must be temporal for ILT edition')
        return
    }

    if (!event.begin || !event.end) {
        console.error("Event must have valids 'begin' and 'end' for ILT edition")
        return
    }

    // console.log("ILTEditionAnnotationEventForm props", props)

    const beginValue = DateService.getMoment(parseInt(event.begin))
    const endValue = DateService.getMoment(parseInt(event.end))

    const bit_crossing_1000_timestamp = event?.extra?.manual_bit_crossing_1000_timestamp ?? event?.bit_crossing_1000_timestamp ?? null
    const bit_crossing_casing_shoe_timestamp = event?.extra?.manual_bit_crossing_casing_shoe_timestamp ?? event?.bit_crossing_casing_shoe_timestamp ?? null

    const bit_crossing_1000_value = bit_crossing_1000_timestamp ? DateService.getMoment(parseInt(bit_crossing_1000_timestamp)) : null
    const bit_crossing_casing_shoe_value = bit_crossing_casing_shoe_timestamp ? DateService.getMoment(parseInt(bit_crossing_casing_shoe_timestamp)) : null

    const { state, params, ...context } = useContext(DashboardContext)
    const [iltActivitiesOptions, setIltActivitiesOptions] = useState([])
    const [iltSubActivitiesOptions, setIltSubActivitiesOptions] = useState([])
    const [iltSubActivitiesColors, setIltSubActivitiesColors] = useState({})
    const [ddrCodesOptions, setDdrCodesOptions] = useState([])
    const [ddrSubCodesOptions, setDdrSubCodesOptions] = useState([])
    const [sectionsOptions, setSectionsOptions] = useState([])
    const [form, setForm] = useState<ILTEditionForm>({
        manual_depthFrom: event?.extra?.manual_depthFrom ?? event?.from_depth_final,
        manual_depthTo: event?.extra?.manual_depthTo ?? event?.to_depth_final,
        manual_exclude: event?.extra?.manual_exclude ?? event?.exclude ?? false,
        manual_iltActivity: event?.extra?.manual_iltActivity ?? event?.activity_name_final_event,
        manual_iltSubActivity: event?.extra?.manual_iltSubActivity ?? event?.sub_activity_name_final_event,
        manual_code: event?.extra?.manual_code ?? event?.code,
        manual_subcode: event?.extra?.manual_subcode ?? event?.subcode,
        manual_timeType: event?.extra?.manual_timeType ?? event?.time_type,
        manual_section: event?.extra?.manual_section ?? event?.section_name,
        bit_crossing_1000_date: bit_crossing_1000_value,
        bit_crossing_1000_time: bit_crossing_1000_value ? bit_crossing_1000_value.format('HH:mm:ss') : null,
        bit_crossing_casing_shoe_date: bit_crossing_casing_shoe_value,
        bit_crossing_casing_shoe_time: bit_crossing_casing_shoe_value ? bit_crossing_casing_shoe_value.format('HH:mm:ss') : null,
        fromDate: beginValue,
        fromTime: beginValue.format('HH:mm:ss'),
        toDate: endValue,
        toTime: endValue.format('HH:mm:ss'),
    })
    const [errors, setErrors] = useState({})
    const wellName = event?.wellbore_name ?? event?.extra?.wellbore_name ?? getWellName(params.filter)
    const saveDisabled = !form.manual_iltSubActivity || Object.values(errors).some(e => e)

    useEffect(() => {
        const errors = {
            bit_crossing_1000_date: validateTimestamp(form.bit_crossing_1000_date, form.bit_crossing_1000_time),
            bit_crossing_1000_time: validateTimestamp(form.bit_crossing_1000_date, form.bit_crossing_1000_time),
            bit_crossing_casing_shoe_date: validateTimestamp(form.bit_crossing_casing_shoe_date, form.bit_crossing_casing_shoe_time),
            bit_crossing_casing_shoe_time: validateTimestamp(form.bit_crossing_casing_shoe_date, form.bit_crossing_casing_shoe_time)
        }

        // console.log('form change', form, errors)
        setErrors(errors)
    }, [form])

    // useEffect(() => {
    //     onHide()
    // }, [wellName, state?.currentSpan])

    useEffect(() => {
        const controller = new AbortController()
        const signal = controller.signal
        api.getLookupTable(signal, 'options_ilt_activities').then(r => {
            setIltActivitiesOptions(r.entries.map(({ key }) => ({ value: key, label: key })))
        })
    }, [])

    useEffect(() => {
        const controller = new AbortController()
        const signal = controller.signal
        api.getLookupTable(signal, 'options_ilt_subactivities').then(r => {
            setIltSubActivitiesOptions(r.entries.map(({ key }) => ({ value: key, label: key })))
            setIltSubActivitiesColors(r.entries.reduce((map, p) => {
                map[p.key] = p.value
                return map
            }, {}))
        })
    }, [])

    useEffect(() => {
        const controller = new AbortController()
        const signal = controller.signal
        api.getLookupTable(signal, 'options_ddr_code').then(r => {
            setDdrCodesOptions(r.entries.map(({ key }) => ({ value: key, label: key })))
        })
    }, [])

    useEffect(() => {
        const controller = new AbortController()
        const signal = controller.signal
        api.getLookupTable(signal, 'options_ddr_subcode').then(r => {
            setDdrSubCodesOptions(r.entries.map(({ key }) => ({ value: key, label: key })))
        })
    }, [])

    useEffect(() => {
        const controller = new AbortController()
        const signal = controller.signal
        api.getLookupTable(signal, 'options_sections').then(r => {
            setSectionsOptions(r.entries.map(({ key }) => ({ value: key, label: key })))
        })
    }, [])

    function onSubmit() {
        const payload = {
            ...event,
            extra: makeExtra(event, form, wellName),
            uid: (event && event.uid) || undefined,
            begin: getUnixFromDateAndTime(form.fromDate, form.fromTime),
            end: getUnixFromDateAndTime(form.toDate, form.toTime),
            __src: __SOURCE_ILT__,
            __color: iltSubActivitiesColors[form.manual_iltSubActivity],
            message: form.manual_iltSubActivity,
            activeDashboardFilters: props.activeDashboardFilters,
        }

        payload['extra']['history'] = makeHisotry(event, payload)

        api.createAnnotation(payload).then(e => {
            onHide()
        })
    }

    return <ContainerBody>
        {props.editing ? <EditingHeader title={"ILT Edition"}/> : null }
        <div className="timeline__form">
            <Selector label="Sub Activity" property="manual_iltSubActivity" options={iltSubActivitiesOptions} form={form} setForm={setForm} required={true} />
            <Selector label="Activity" property="manual_iltActivity" options={iltActivitiesOptions} form={form} setForm={setForm} />
            <WrapperDepth>
                <Selector label="Code" property="manual_code" options={ddrCodesOptions} form={form} setForm={setForm} />
                <Selector label="Sub Code" property="manual_subcode" options={ddrSubCodesOptions} form={form} setForm={setForm} />
            </WrapperDepth>
            <WrapperDepth>
                <Selector label="Operation Type" property="manual_timeType" options={operationTypeOptions} form={form} setForm={setForm} />
                <Selector label="Exclude" property="manual_exclude" options={exclusionOptions} form={form} setForm={setForm} />
            </WrapperDepth>
            <Selector label="Section" property="manual_section" options={sectionsOptions} form={form} setForm={setForm} />
            {/* <br /> */}
            <WrapperDepth>
                <DepthInput label="Depth From" property="manual_depthFrom" form={form} setForm={setForm} />
                <DepthInput label="Depth To" property="manual_depthTo" form={form} setForm={setForm} />
            </WrapperDepth>
            <br />
            <WrapperDepth className="mb-20">
                <CustomDatePicker label="Bit Crossing 1000ft" propertyDate="bit_crossing_1000_date" propertyTime="bit_crossing_1000_time" value={bit_crossing_1000_value} form={form} setForm={setForm} errors={errors} />
                <CustomDatePicker label="Bit Crossing Casing Shoe" propertyDate="bit_crossing_casing_shoe_date" propertyTime="bit_crossing_casing_shoe_time" value={bit_crossing_casing_shoe_value} form={form} setForm={setForm} errors={errors} />
            </WrapperDepth>
            {/* <br /> */}
            <WrapperDepth className="mb-20">
                <FromDatePicker beginValue={beginValue} form={form} setForm={setForm} errors={errors} disabled={true} />
                <ToDatePicker endValue={endValue} form={form} setForm={setForm} errors={errors} disabled={true} />
            </WrapperDepth>
            <br />
            <Footer form={form} onSubmit={onSubmit} disabled={saveDisabled} onHide={onHide} />
        </div>
    </ContainerBody >
}